import { StyleSheet } from 'react-native'

import { moderateScale } from '../../styles/sizes'
import { fontFamily } from '../../theme'

export const styles = StyleSheet.create({
  headerContainer: {
    width: '100%',
    height: 58,
    flexDirection: 'row',
    paddingHorizontal: 24,
    justifyContent: 'space-between'
  },
  itemLeft: {
    width: '25%',
    justifyContent: 'center'
  },
  itemCenter: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  itemRight: {
    marginLeft: 12
  },
  leftIcon: {
    height: 24,
    width: 24
  },
  logoIcon: {
    height: 30,
    width: 150
  },
  rightIcon: {
    height: 24,
    width: 24
  },
  title: {
    fontSize: moderateScale(18),
    fontFamily: fontFamily.GTAmericaStandardMedium,
    color: '#fff',
    textAlignVertical: 'center'
  },
  itemLeftContainer: {
    width: '25%',
    flexDirection: 'row',
    alignItems: 'center'
  },
  // A title takes whatever the right items leave, so it is not cut off at a quarter width.
  itemLeftContainerFill: {
    width: undefined,
    flex: 1,
    marginRight: 12
  },
  // Inside the filled container a percentage width would grow with it; size to the icon.
  itemLeftFit: {
    width: undefined
  },
  // Lets the title shrink within the row so the ellipsis lands at the row's edge.
  titleFill: {
    flexShrink: 1
  },
  itemRightContainer: {
    width: '25%',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  eyeEmptyView: {
    height: moderateScale(16),
    minWidth: 30
  },
  logoContainer: {
    flexDirection: 'row',
    gap: 8
  },
  keyLiveEventIcon: {
    position: 'absolute',
    zIndex: 1,
    right: 0,
    width: 8,
    height: 8,
    borderRadius: 5,
    top: -2,
    backgroundColor: '#FF7222'
  }
})
